import { BackButton } from '@/components/web-back-button'

interface Props {
  title: string
  showBackButton?: boolean
}

export const SchoolAdminPageDetailBanner = ({
  title,
  showBackButton = true,
}: Props): JSX.Element => {
  return (
    <div className="flex h-[80px] items-center justify-center border border-b-disable bg-white px-6">
      {showBackButton ? (
        <BackButton className="relative" />
      ) : (
        <div className="w-[90px]" />
      )}
      <h2 className="flex-1 text-center text-[28px]">{title}</h2>
      <div className="w-[90px]"></div>
    </div>
  )
}
